<style>
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body" style="margin-top: -4%;">
            <form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
                <div class="form-group card-with-shadow p-2 mt-3">

                    <div class="row">   
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="del_date_to_warehouse" class="label"> {{ $t("del_date_to_warehouse") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('del_date_to_warehouse')"
                                    v-model="inputs.del_date_to_warehouse"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="lot_number" class="label"> {{ $t("lot_number") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('lot_number')"
                                    v-model="inputs.lot_number"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="cases_per_pallet" class="label"> {{ $t("cases_per_pallet") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('cases_per_pallet')"
                                    v-model="inputs.cases_per_pallet"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="number_of_pallets" class="label"> {{ $t("number_of_pallets") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('number_of_pallets')"
                                    v-model="inputs.number_of_pallets"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div> 

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="date_released" class="label"> {{ $t("date_released") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('date_released')"
                                    v-model="inputs.date_released"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div> 

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="warehouse_location" class="label"> {{ $t("warehouse_location") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('warehouse_location')"
                                    v-model="inputs.warehouse_location"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="mt-5 col-md-3 action-buttons">
                        <button type="button" class="btn btn-primary mr-2  w-100" 
                            @click="save"
                            :disabled="isDisabled"    
                        >
                            {{ $t('save') }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';

export default {
    name: "add_contractDetail_form",
    mixins: [FormMixin],
    data() {
        return {
            isDisabled : true,
            inputs: {
                del_date_to_warehouse : null,
                lot_number : null,
                cases_per_pallet : null,
                date_released : null,
                number_of_pallets : null,
                warehouse_location: null,
            },
            preloader : false,
        }  
    },
    methods: {
        async save(){
            this.preloader = true;
            try {
                const { data } = await axios.post(
                    `/api/subcontract/save_inventory/${this.contractId}`,
                    this.inputs
                );
                this.$toastr.s(data.message || this.$t('saved_successfully'));
            } catch (e) {
                const errors = e.response?.data?.errors;
                const msg = errors
                    ? Object.values(errors)[0][0]
                    : (e.response?.data?.message || this.$t('something_went_wrong'));
                this.$toastr.e(msg);
            } finally {
                this.preloader = false;
            }
        },

        async loadData() {
            try {
                this.preloader = true;
                const { data } = await axios.get(
                    `/api/subcontract/get_inventory/${this.contractId}`
                );
                if (data) {
                    Object.keys(this.inputs).forEach(key => {
                        this.inputs[key] = data[key] ?? null;
                    });
                }
                this.preloader = false;
            } catch (e) {
                console.log(`errro ${e}`);
                this.preloader = false;
            }
        },
    },

    watch : {
        inputs : {
            deep : true,
            handler(newVal){

            }
        }
    },

    props: {
        props: { type: Object, default: () => ({}) }
    },

    mounted() {    
        this.contractId = this.props?.id ?? this.$route?.params?.id ?? null;
        if (!this.contractId) {
            console.warn('subcontract id not found', this.props, this.$route?.params);
            return;
        }
        this.loadData();   
        let isLogisticCoordinator = false;
        const roles = user.roles;
        roles.forEach( rol => {
            if (rol.name === 'Logistics Coordinator') {
                isLogisticCoordinator = true;
            }
        });
        if (isLogisticCoordinator) {
            this.isDisabled = false;
        }
    },
}
</script>
